// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1pxjM","productName":"Table_productName__2TeGh"};